const validations = [
    {
        field: 'termsOfUseText',
        method: 'isEmpty',
        validWhen: false,
        message: 'Terms Of Use is a required field.'
    },
    {
        field: 'privacyPolicyText',
        method: 'isEmpty',
        validWhen: false,
        message: 'Privacy Policy is a required field.'
    }
];

export default validations;
